import { type FunctionComponent, useState } from "react";
import { LL0 } from "@/react/core/I18nService.tsx";
import { createRoomObject, EditorMode, LIST_TREE, setMode0 } from "@/react/EditRoomView/EditRoomView.tsx";
import type { TreeInfo } from "@/data/Room.ts";

type TreeSelectionPopupType = {
  onClose?: () => void;
  onComplete?: () => void;
};


const TreeSelectionPopup: FunctionComponent<TreeSelectionPopupType> = ({
  onClose,
  onComplete
}) => {
  const [activeTree, setActiveTree] = useState<TreeInfo>({id: 1, name: "Tree 1", treeSrc: "/tree-1@2x.png"});

  const handleTreeClick = (id = 1) => {
    const _treeInfo = LIST_TREE.find(tree=> tree.id === id)!;
    setActiveTree(_treeInfo);
  };
  return (
    <div className="bg-basic-color-white w-full h-full flex flex-col items-end justify-start py-[21px] px-[26px] box-border gap-[30px] max-w-full max-h-full overflow-auto text-left text-base text-royalblue-300 font-mulish">
      <div className="self-stretch flex flex-row items-start justify-between">
        <b className="relative">{LL0().restaurant.treeSelection()}:</b>
        <img
          className="relative w-[20.4px] h-[20.4px] cursor-pointer"
          alt=""
          src="/cancel-icon.svg"
          onClick={onClose}
        />
      </div>
      <div className="no-scrollbar self-stretch overflow-y-auto gap-[13px] grid grid-cols-[repeat(1,minmax(80px,auto))_minmax(80px,auto)_repeat(1,minmax(80px,auto))_minmax(80px,auto)_repeat(1,minmax(80px,auto))_minmax(auto,80px)] [grid-row-gap:20px] [grid-column-gap:13px]">
        {LIST_TREE.map((tree) => (
          <div
            key={tree.id}
            className={`w-20 h-20 flex flex-row items-start justify-start relative gap-[10px] ${activeTree === tree.id ? 'border-4 border-blue-500' : ''}`}
            onClick={() => handleTreeClick(tree?.id || 1)}
          >
            <img
              className="self-stretch flex-1 relative max-w-full overflow-hidden max-h-full object-cover z-[0]"
              alt={tree.name}
              src={tree.treeSrc}
            />
            {activeTree.id === tree.id && (
              <img
                className="absolute my-0 mx-[!important] top-[calc(50%_-_10px)] left-[calc(50%_-_11px)] w-[21px] h-[21px] z-[1]"
                alt="Active"
                src="/checked-icon.svg"
              />
            )}
          </div>
        ))}

      </div>
      <div className="flex flex-row items-end justify-end gap-[12px] text-center text-mini">
        <div
          className="rounded-md box-border w-[121px] h-9 flex flex-row items-center justify-center cursor-pointer border-[1px] border-solid border-royalblue-100"
          onClick={onClose}
        >
          <div className="relative font-semibold">{LL0().ui.cancel()}</div>
        </div>
        <div className="rounded-md bg-royalblue-100 w-[121px] h-9 overflow-hidden shrink-0 flex flex-row items-center justify-center text-basic-color-white"
             onClick={async () => {
               await createRoomObject('tree',activeTree)
               setMode0(EditorMode.Tree)
               onClose?.();
             }}
        >
          <div className="relative font-semibold uppercase">{LL0().ui.ok()}</div>
        </div>
      </div>
    </div>
  );
};

export default TreeSelectionPopup;
